import { DOLPHIN_API, KENSHIN_API } from 'shared/constants/apis';
import { USER_DATA } from 'shared/constants/users';
import api from 'utils/api';
import localData from 'utils/localData';

export const updateMyWage = (wageId, updatedFields) => {
  api.put(`${DOLPHIN_API.MY_WAGE}/${wageId}`, {
    params: {
      organizationId: localData.get(USER_DATA.CURRENT_ORGANIZATION_ID),
    },
    data: updatedFields,
  });
};

export const updateMyWageKenshin = (wageId, updatedFields) => {
  api.put(`${KENSHIN_API.MY_WAGE}/${wageId}`, {
    baseURL: import.meta.env.VITE_KENSHIN_API_URL,
    params: {
      organizationId: localData.get(USER_DATA.CURRENT_ORGANIZATION_ID),
      userId: localData.get(USER_DATA.USER_ID),
    },
    data: updatedFields,
  });
};

export const updatePaidWage = (wageId, updatedFields) => {
  api.put(`${DOLPHIN_API.PAID_WAGE}/${wageId}`, {
    params: {
      organizationId: localData.get(USER_DATA.CURRENT_ORGANIZATION_ID),
    },
    data: updatedFields,
  });
};

export const updatePaidWageKenshin = (wageId, updatedFields) => {
  api.put(`${KENSHIN_API.PAID_WAGE}/${wageId}`, {
    baseURL: import.meta.env.VITE_KENSHIN_API_URL,
    params: {
      organizationId: localData.get(USER_DATA.CURRENT_ORGANIZATION_ID),
      userId: localData.get(USER_DATA.USER_ID),
    },
    data: updatedFields,
  });
};
